module.exports = __webpack_public_path__ + "static/media/mobile-welcome3.8da85a7e.png";